import tenantAxiosInstance from "../utils/tenantAxiosInstance";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const version = 'v1';


const getHomePage = (tenant_id, user_id, body = {}) => {
  return tenantAxiosInstance
    .post(API_URL + `${version}/report/consolidated/${tenant_id}/${user_id}`, body)
    .then((response) => {
      return response.data;
    });
};

const getKeywordTrends = (tenant_id, user_id, body = {}) => {
  return tenantAxiosInstance
    .post(API_URL + `${version}/consolidated/keywordtrends/${tenant_id}/${user_id}`, body)
    .then((response) => {
      return response.data;
    });
};
const StartTheConv = (tenant_id,body) => {
  return tenantAxiosInstance
  .post(API_URL + `chat/sessions/${tenant_id}/start`, body)
  .then((response) => {
    return response.data;
  });
}
const ChatConv = (tenant_id,body) => {
  return tenantAxiosInstance
  .post(API_URL + `chat/conversation/${tenant_id}`, body)
  .then((response) => {
    return response.data;
  });
}

const getStatusConv = (tenant_id,status_id) => {
  return tenantAxiosInstance
  .get(API_URL + `chat/messages/status/${tenant_id}/${status_id}`)
  .then((response) => {
    return response.data;
  });
}
const getTheConv = (tenant_id,sessionId) => {
  return tenantAxiosInstance
  .get(API_URL + `chat/conversation/${tenant_id}/${sessionId}`)
  .then((response) => {
    return response.data;
  });
}

const getAllChats = (tenant_id) => {
  return tenantAxiosInstance
  .get(API_URL + `chat/sessions/${tenant_id}`)
  .then((response) => {
    return response.data;
  });
}

const DeleteChatData = (tenant_id,session_id) => {
  return tenantAxiosInstance
  .delete(API_URL + `chat/sessions/${tenant_id}/${session_id}`)
  .then((response) => {
    return response.data;
  });
}


const renameTheTitle = (tenant_id,session_id,body) => {
  return tenantAxiosInstance
  .patch(API_URL + `chat/sessions/${tenant_id}/${session_id}`,body)
  .then((response) => {
    return response.data;
  });
}

const matViewRef = (tenant_id) => {
  return tenantAxiosInstance
  .get(API_URL + `chat/matview/${tenant_id}`)
  .then((response) => {
    return response.data;
  });
}

const HomePageServices = {
  getHomePage,
  getKeywordTrends,
  renameTheTitle,
  StartTheConv,
  getTheConv,
  ChatConv,
  getAllChats,
  getStatusConv,
  matViewRef,
  DeleteChatData
};

export default HomePageServices;